// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__narkisCondensed_b5828d', '__narkisCondensed_Fallback_b5828d'"},"className":"__className_b5828d","variable":"__variable_b5828d"};